import { iServerVars } from 'shared/iServerVars';

// @ts-ignore
const wServerVars = window?.ServerVars;

export const ServerVars: iServerVars = wServerVars || {
  ALLOW_signup: true,
};
